<template>
  <div>
    <div id="home"></div>

    <v-img src="/static/img/home/acropolis/home5.jpg" class="rooms-img">
      <div class="offer1-mask text-xs-center">
        <v-container>
          <div class="offer1-offer">Сауны с бассейном</div>
          <!--
            <div class="offer1-sub-offer">Пятый час в подарок! При оплате четырех часов, пятый час вы получаете в подарок.</div>
          -->

          <app-modal-form
            button-text="Забронировать сауну"
            modal-form-header="Забронируйте"
            modal-form-sub-header="сауну прямо сейчас"
            modal-form-button-text="Забронировать сауну"
            form-name="Акрополь - Сауна - главный"
          ></app-modal-form>

        </v-container>
      </div>
    </v-img>

    <v-container class="screen rooms">
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <h1 class="text-xs-center">Сауна на любой выбор</h1>
        </v-flex>
        <v-flex
          d-flex
          xs12
          sm8
          md4
          v-for="hammam in hammams"
          :key="hammam.id"
        >
        <div class="rooms-block">
          <router-link :to="'/acropolis/hammam/' + hammam.id">
            <v-img :src="hammam.img" height="300px"></v-img>
            <div style="padding: 15px;">
              <div class="rooms-h1">{{ hammam.name }}</div>
              <div class="rooms-description">{{ hammam.description }}</div>
              <div class="rooms-price">{{ hammam.price }}</div>
              <v-btn color="green" large flat>Подробнее</v-btn>
            </div>
          </router-link>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container class="screen2 rooms">
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <h1 class="text-xs-center">Дополнительные услуги</h1>
        </v-flex>
        <v-flex
          d-flex
          xs12
          sm8
          md4
          v-for="uslugi in uslugis"
          :key="uslugi.id"
        >
          <div class="rooms-block">
              <v-img :src="uslugi.img"></v-img>
              <div style="padding: 15px 15px 25px 15px;">
                <div class="rooms-h1">{{ uslugi.name }}</div>
                <div class="rooms-description">{{ uslugi.description }}</div>
                <div class="rooms-price">{{ uslugi.price }}</div>
              </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <app-acropolis-plus class-name="screen2"></app-acropolis-plus>
    <app-acropolis-reviews></app-acropolis-reviews>
    <app-acropolis-contacts></app-acropolis-contacts>

    <app-button-go-back :goto="goto"></app-button-go-back>

  </div>
</template>

<script>
export default {
  data () {
    return {
      goto: { path: '/acropolis' },
      hammams: this.$store.state.acropolisHammams,
      uslugis: [
        {
          id: 1,
          img: '/static/img/sauna/bil3.jpg',
          name: 'Бильярд',
          description: 'Дополнительная услуга для наших гостей.',
          price: '150 руб./час'
        },
        {
          id: 2,
          img: '/static/img/sauna/2.jpg',
          name: 'Караоке',
          description: 'Дополнительная услуга для наших гостей.',
          price: '150 руб./час'
        },
        {
          id: 3,
          img: '/static/img/sauna/3.jpg',
          name: 'Тапочки, полотенца, веники, простыни',
          description: 'Дополнительная услуга для наших гостей.',
          price: 'от 100 руб.'
        }
      ]
    }
  }
}
</script>

<style scoped>
#home {
  position: relative;
  top: -150px;
}

.rooms a,
.rooms a:active,
.rooms a:hover,
.rooms a:visited {
  color: black;
  text-decoration: none;
}

.rooms-img {
  height: 80vh;
}

.rooms h1 {
  margin-bottom: 50px;
}

.rooms-block {
  margin: 15px;
  text-align: center;
  border: 1px solid #c3c3c3;
  border-radius: 5px;
}

.rooms-block:hover {
  background-color: #f5f5f5;
  opacity: 0.8;
}

.rooms-h1 {
  font-size: 21px;
  font-weight: 900;
  margin-top: 15px;
}

.rooms-description {
  margin-top: 10px;
  margin-bottom: 10px;
}

.rooms-price {
  font-size: 21px;
  font-weight: 900;
  color: green;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .rooms h1 {
    margin-bottom: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/acropolis/Hammams.vue